import { render, staticRenderFns } from "./dg-link.vue?vue&type=template&id=4f4136ac&scoped=true"
import script from "./dg-link.vue?vue&type=script&lang=js"
export * from "./dg-link.vue?vue&type=script&lang=js"
import style0 from "./dg-link.vue?vue&type=style&index=0&id=4f4136ac&prod&lang=less&scoped=true"
import style1 from "./dg-link.vue?vue&type=style&index=1&id=4f4136ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4136ac",
  null
  
)

export default component.exports